module.exports = __webpack_public_path__ + "img/7.d8e643bd.jpg";